const zh_CN = {
  'join': '加入',
  'regular': '普通',
  'rare': '稀有',
  'epic': '史诗',
  'legendary': '传奇',
  'no_rank': ' ',
  'genesis': '创世',
  'no_nft': '抱歉未抽中',
  'has_nft': '恭喜已抽中',
  'award': '奖励',
  'no_mint': '还未铸造过APE Genesis NFT',
  'apply': '申请',
  'rank': '等级',
  'follow': '关注',
  'total': '小计',
  'click_draw': '点击抽取',
  'section_1_p1': '欢迎来到',
  'section_1_p3': '拥有创世NFT',
  'section_1_p4': '即可获得VIP 会员身份',
  'section_2_span_1': '什么是',
  'section_2_span_2': '创世NFT？',
  'section_2_p1_1': '创世NFT，是专门为APENFT MarketPlace铸造的限量版NFT，总共发行',
  'section_2_p1_2': '枚，分为普通、稀有、史诗、传奇四个等级。等级越高，享受的权益越多。',
  'section_2_p2': '创世NFT是进入APENFT VIP Club的门票。VIP Club的会员可以享受波场生态上的多个项目的白名单福利，以及其他各种独家福利。',
  'section_3_rank1_p2': '剩余',
  'section_3_rank2_p2': '剩余',
  'section_3_rank3_p2': '剩余',
  'section_3_rank4_p2': '剩余',
  'section_3_rank1_title': '获得 普通级别 创世NFT的标准',
  'section_3_rank2_title': '获得 稀有级别 创世NFT的标准',
  'section_3_rank3_title': '获得 史诗级别 创世NFT的标准',
  'section_3_rank4_title': '获得 传奇级别 创世NFT的标准',
  'section_3_rank_text_p1': 'TronLink钱包内持有以下资产',
  'section_3_rank_foot_p1_1': '总价值在',
  'section_3_rank_foot_p1_2': '即可获得一枚',
  'section_3_rank1_foot_p2': '其中有20%的创世NFT包含价值$50的$NFT TOKEN资产',
  'section_3_rank2_foot_p2': '其中有20%的创世NFT包含价值$200的$NFT TOKEN资产',
  'section_3_rank3_foot_p2': '其中有20%的创世NFT包含价值$2,000的$NFT TOKEN资产',
  'section_3_rank_foot_p3': '钱包快照以2022年3月1日0:00AM(UTC)的区块高度数据为准。',
  'section_3_rank4_footer_p': '由 Tron DAO进行社区投票选举决定',
  'section_4_title_p1': '如果您的TronLink钱包资产不符合领取条件',
  'section_4_title_p2': '但您需符合以下身份',
  'section_4_content_p1': '· POLONIEX的高级交易用户',
  'section_4_content_p2': '· 加密领域的KOL或者媒体机构',
  'section_4_content_p3': '· 参与平台预注册的邀请活动的用户',
  'section_4_content_p4': '· 曾经丢失过$NFT或TRX资产',
  'section_4_content_p5': '· NFT领域的艺术家',
  'section_4_content_p6': '· 区块链上开发者',
  'section_4_button': '请加入DISCORD社群领取',
  'section_6_title_1': '您可以抽取一个',
  'section_6_title_2': '的创世NFT',
  'eligibility_review': '资格审核',
  'assets_date': '截止2022年3月1日，您所持有的资产',
  'currency': '数字货币',
  'collection_hold': '所持有的数字藏品',
  'exchange_rate': '汇率',
  'rate_base': '汇率基于3月1日',
  'value': '价值',
  'success_p1': '恭喜您通过审核，您可以抽取APENFT的创世NFT。',
  'success_p2_1': '您有机会抽取 ',
  'or': ' 或 ',
  'success_p2_2': ' 级别的创世NFT。',
  'fail_p1': '抱歉，通过您的资产记录，您未能达成资产持有的标准。',
  'fail_p2': '但我们仍然为您提供了获取创世NFT的其他途径。',
  'fail_p3_1': '具体信息，您可以加入我们的',
  'fail_p3_2': '社区进行咨询。',
  'already_p1': '您已拥有创世NFT。',
  'already_p2': '活动仅可参加一次。',
  'draw_genesis': '抽取创世',
  'cancel': '取消',
  'already_claimed_1': '您已拥有创世NFT。',
  'already_claimed_2': '活动仅可参加一次。',
  'assets_not_enough': '您的TronLink钱包资产不符合领取条件。',
  'contact_us': '联系我们',
  'footer_h5': '您可以关注APENFT MarketPlace的最新动态了解我们最新发布的功能，NFT的投放以及使用APENFT MarketPlace的各种技巧。',
  'footer_tail': 'APENFT.io致力于汇聚全球顶尖的创作型艺术家以及知名IP，搭建高价值数字艺术品平台，为顶尖优秀的创作者、高知名度IP与苛求完美的收藏家建立稳固的桥梁，提供稳定、安全、高效的去中心化服务。',
  'login_to_claim': '请连接TronLink来领取你的NFT',
  'no_tronlink': '没有TronLink？',
  'tronlink_not_login': '未登录TronLink',
  'tronlink_not_connected': '未连接TronLink',
  'tronlink_not_install': '未安装TronLink',
  'install': '安装',
  'congratulation': '恭喜! 获得',
  'fail_to_claim': '领取失败',
  'hit_p1': '与此同时，你还可以获得',
  'hit_p2': '它将在7个工作日内发送到您的TRC20地址。请保持查看！',
  'token': '通证',
  'not_main_net': '链接的不是TRON主网',
  'trigger_contract_failed': '触发合约失败',
  'asset_value': ' 持有资产价值 ',
  'contract_address': '合约地址：',
  'refresh_to_login_1': '如果您已经登录您的TronLink',
  'refresh_to_login_2': '请刷新本页面来连接您的TronLink钱包',
  'wallet_connect': '连接钱包',
  'to_market': "在APENFT Marketplace 上查看该收藏品",


};

export default zh_CN